import { PostHogProvider } from "@posthog/react";
import type { PostHogConfig } from "posthog-js";
import type { ReactElement, ReactNode } from "react";

import { POSTHOG_HOST, POSTHOG_PROJECT_TOKEN } from "../../constants/buildFlags";
import { getPostHogApiHost } from "../../services/posthog/posthogHost";

interface PostHogAnalyticsProviderProps {
  children: ReactNode;
}

// `disabled` is a real posthog-js init option (fully disables capture) but is
// missing from the `PostHogConfig` type in the installed posthog-js version.
type PostHogOptionsWithDisabled = Partial<PostHogConfig> & { disabled: boolean };

export function PostHogAnalyticsProvider({
  children,
}: PostHogAnalyticsProviderProps): ReactElement {
  const posthogOptions: PostHogOptionsWithDisabled = {
    api_host: getPostHogApiHost(window.location.hostname, POSTHOG_HOST),
    autocapture: false,
    capture_pageview: false,
    defaults: "2026-01-30",
    disabled: !POSTHOG_PROJECT_TOKEN,
    enable_recording_console_log: true,
    session_recording: {
      recordHeaders: true,
      recordBody: true,
    },
  };

  return (
    <PostHogProvider apiKey={POSTHOG_PROJECT_TOKEN} options={posthogOptions}>
      {children}
    </PostHogProvider>
  );
}
